module.exports = __webpack_public_path__ + "static/transport-22c9f848ec58b0418522320b2060c72d.jpg";